export interface PdfModalState {
    document: string;
    print: boolean;
    visible: boolean;
}


export const pdfModalInitialState: PdfModalState = {
    document: null,
    print: false,
    visible: false,
};
